import type { Action } from "@ebay/experience-types-ebay";

export interface Input {
  zipcode?: string;
  distance?: string;
  "on-location-btn-click"?: () => void;
  locationChangeClickAction?: Action;
}

export default class extends Marko.Component<Input> {
  onLocationBtnClick() {
    this.emit("location-btn-click");
  }
}
